import { Button, DialogFooter, DialogTitle } from "shared/components";
import { Loader2, RotateCcwIcon } from "lucide-react";

import { getText } from "shared/lib";

export interface PreReviewProposalContentProps {
  onClickCancel: () => void;
  onClickSubmit: () => void;
  submitting: boolean;
}

export function PreReviewProposalContent({
  onClickCancel,
  onClickSubmit,
  submitting,
}: PreReviewProposalContentProps) {
  return (
    <>
      <DialogTitle>{getText("Start again?")}</DialogTitle>

      <div className="text-textPrimary flex flex-col gap-4">
        <p className="text-bodylg ">
          {getText(
            "If you restart, you will lose all the responses you've entered.",
          )}
        </p>

        <div className="border-interfaceBorder bg-interfaceBgDefault rounded-xs border-l-4 px-4 py-3">
          <h2 className="text-headingmd mb-1">
            {getText("☝ Want to edit your proposal or change a response?")}
          </h2>
          <p className="text-bodymd">
            {getText(
              "Instead of restarting, answer a few more questions. You'll be able to review and edit your proposal once all questions have been answered.",
            )}
          </p>
        </div>
      </div>

      <DialogFooter>
        <Button onClick={onClickCancel} variant="outline">
          {getText("Cancel")}
        </Button>

        <Button className="gap-2" onClick={onClickSubmit} variant="default">
          {submitting ? (
            <Loader2 className="animate-spin" />
          ) : (
            <RotateCcwIcon className="h-4 w-4" />
          )}
          {getText("Discard and restart")}
        </Button>
      </DialogFooter>
    </>
  );
}
